<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 sm11 md11>
          <h3 class="text-center">Invoices</h3>
          <v-card>
            <v-card-text>
              <invoices-table :invoices="invoices"></invoices-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const InvoicesTable = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "invoices" */ '@/Components/Invoices/invoices.vue')

  export default {
    name: 'Invoices',
    layout,
    props: [
      'invoices'
    ],
    components: {
      InvoicesTable,
    },
    metaInfo () {
      return {
        title: 'Invoices',
        titleTemplate: '%s | ' + this.$title,
      }
    },
  }
</script>
